import type { FC } from "react";
import { BodyCopy } from "./BodyCopy";
import { Button } from "lola-framework-ui-test";
import { useTranslation } from "react-i18next";
import { LimitInfoIcon } from "../assets/icons";
import { TITLE_COLOR } from "../constants";
import { useStore } from "../store/globalState";
import { formatLabeledAmount } from "../utils";

export interface AmountOutOfRangeInfoProps {
  kind: "below_min" | "above_max";
  bound: number;
  currency: string;
  onClose: () => void;
}

/**
 * Crear solicitud gate when the request amount sits outside the partner send
 * envelope. User dismisses and edits the amount they ask for.
 */
export const AmountOutOfRangeInfo: FC<AmountOutOfRangeInfoProps> = ({
  kind,
  bound,
  currency,
  onClose,
}) => {
  const { t } = useTranslation();
  const { theme } = useStore();
  const colorConfig = theme.whiteView;
  const { bodyCopy, backgroundBtn, textColorBtn } = colorConfig;

  const formatted = formatLabeledAmount(bound, currency, {
    minimumFractionDigits: Number.isInteger(bound) ? 0 : 2,
    maximumFractionDigits: Number.isInteger(bound) ? 0 : 2,
  });

  const message =
    kind === "above_max"
      ? t("amountLimit.aboveMax", { max: formatted })
      : t("amountLimit.belowMin", { min: formatted });

  return (
    <section className="amount-limit-slot">
      <LimitInfoIcon size={60} colors={[TITLE_COLOR, TITLE_COLOR]} />
      <h2 className="amount-limit-heading" style={{ color: TITLE_COLOR }}>
        {t("amountLimit.title")}
      </h2>
      <BodyCopy className="amount-limit-text" textColor={bodyCopy}>
        {message}
      </BodyCopy>
      <Button
        size="large"
        background={backgroundBtn}
        color={textColorBtn}
        onClick={onClose}
      >
        {t("amountLimit.gotIt")}
      </Button>
    </section>
  );
};
